import React from "react";
import "./PlaylistTrackList.scss";
import Strings from "../../config/Strings";
import logo from "../../../assets/images/loader_bg.png";

//the duration of a playlist item is given in seconds, e.g. 109 -> "1:49"
export function formatTrackDuration(seconds) {
    if (seconds == null || isNaN(seconds) || seconds < 0) {
        return "";
    }
    const totalSeconds = Math.round(seconds);
    const minutes = Math.floor(totalSeconds / 60);
    const remainingSeconds = totalSeconds % 60;
    return minutes + ":" + String(remainingSeconds).padStart(2, "0");
}

//shows the tracks of a product with classification PLAYLIST (product._embedded.playlistItems) in playlist order
export function PlaylistTrackList({playlistItems}) {
    if (!playlistItems || playlistItems.length === 0) {
        return null;
    }

    return (
        <div className="playlist-track-list">
            <h2 className="playlist-track-list-headline">
                {Strings.PRODUCT_DETAILS_PLAYLIST_TRACKS.replace("{0}", playlistItems.length)}
            </h2>
            <ol className="playlist-track-list-items">
                {playlistItems.map((item, index) => (
                    <li className="playlist-track" key={item.id != null ? item.id : index}>
                        <span className="playlist-track-number">{index + 1}</span>
                        <img className="playlist-track-cover"
                             src={item.itemCoverUrl ? item.itemCoverUrl : logo}
                             loading="lazy"
                             alt={"Titelbild des Albums von " + item.title}/>
                        <div className="playlist-track-text">
                            <div className="playlist-track-title">{item.title}</div>
                            {item.displayArtistName &&
                                <div className="playlist-track-artist">{item.displayArtistName}</div>
                            }
                        </div>
                        <span className="playlist-track-duration">{formatTrackDuration(item.duration)}</span>
                    </li>
                ))}
            </ol>
        </div>
    );
}
